export class ShippingMapper {
    static toDto(shipping: any): number {
        return shipping.resultado.Costo;
    }
}